<template>
  <div class="text-new-card--title-black">
    <img
      v-if="srcFavicon && !isMainHost"
      v-show="faviconLoaded"
      v-lazy-load
      :src="srcFavicon"
      :alt="srcHostname"
      class="size-full min-w-[16px]"
      @load="handleLoadIcon"
    />
    <SvgIcon
      v-show="!faviconLoaded"
      name="bookmark-filled"
      class="size-full min-h-full min-w-[16px] text-ruby-red-100"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  link: {
    type: String,
    default: null,
  },

  faviconSize: {
    type: Number,
    default: 32,
  },
});
const faviconLoaded = ref(false);

const srcHostname = computed(() => {
  if (!props.link) return null;
  const url = new URL(props.link);
  return url.hostname;
});

const srcFavicon = computed(() => {
  if (!srcHostname.value) return null;
  return `https://www.google.com/s2/favicons?sz=${props.faviconSize}&domain=${srcHostname.value}`;
});

// const srcTitle = computed(() => {
//   if (!this.srcHostname) return 'История РФ';
//   return 'Российское военно-историческое общество';
// });

const isMainHost = computed(() => srcHostname.value === 'histrf.ru');

const handleLoadIcon = () => {
  faviconLoaded.value = true;
};
</script>

<style scoped lang="scss"></style>
